import PropTypes from 'prop-types';
// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { TextField } from '@mui/material';

// ----------------------------------------------------------------------

RHFTextField.propTypes = {
  name: PropTypes.string,
  maxInput: PropTypes.number,
};

export default function RHFTextField({ name, maxInput = 0, ...other }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          onChange={(e) => {
            if (maxInput !== 0 && e.target.value?.toString()?.length <= maxInput) {
              field.onChange(e);
            }
            if (maxInput === 0) {
              field.onChange(e);
            }
          }}
          fullWidth
          error={!!error}
          helperText={error?.message}
          {...other}
          onWheel={(e) => e.target.blur()}
        />
      )}
    />
  );
}
